let language = {
    ORDER_DETAIL_TITLE: "订单信息",
    ORDER_DETAIL_STATUS: "订单状态",
    ORDER_DETAIL_PAY_TIPS: "(您可以在创建订单后 {{paymentWaitingTime}} 分钟内支付此订单，否则它将在 {{paymentWaitingTime}} 分钟后取消。)",
    ORDER_DETAIL_INVOICE: "发票",
    ORDER_DETAIL_CANCEL: "取消",
    ORDER_DETAIL_REORDER: "重新订购",
    ORDER_DETAIL_NUMBER: "订单号",
    ORDER_DETAIL_CREATION_TIME: "创建时间",
    ORDER_DETAIL_PAYMENT_TIME: "付款时间",
    ORDER_DETAIL_SHIPPING: "送货地址",
    ORDER_DETAIL_BILLING: "账单地址",
    ORDER_DETAIL_DELIVERY: "配送方式",
    ORDER_DETAIL_PAYMENT: "付款方式",
    ORDER_DETAIL_TRACKING_NO: "物流单号",
    ORDER_DETAIL_PAY_FAILED_DES1: "订单付款失败，您可以去",
    ORDER_DETAIL_PAY_FAILED_DES2: "查看原因。"
};

export { language }
